import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'

import Modalizer from 'components/modalizer/modalizer'
import { MainButton, CancelButton } from 'components/button'
import TextLink from 'components/text_link/text_link'
import CheckboxInput from 'components/checkbox/checkbox'
import { TextInput } from 'components/dpc_input'
import binderActions from 'redux/actions/binderActions'
import generalActions from 'redux/actions/generalActions'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { localize } from 'helpers/translator'

import styles from './binders_create_modal.scss'

const bindersIcon = <svg height="27" width="21" viewBox="0 0 21 27"><path d="M15.97 14.54h.42v-.83H8.05v.83h.42zm0-2.09h.42v-.84H8.05v.84h.42zm0-2.1h.42v-.84H8.05v.84h.42zm-4.22-2.51h.42V7H8v.84h.42z" fill="#ae74f0"/><path d="M6.19 18.13c0 .01 11.71.09 11.71.09.01 0 .002-9.184 0-11.102L12.668 1.84H5.99c.01 0 .2 16.29.2 16.29zM17.9 7.118l.24.242-.24-.59v.348zM12.668 1.84h.342l-.59-.25zM5.99 1h7.02l5.72 5.77v11.45c0 .46-.37.84-.83.83l-11.7-.06c-.46-.01-.84-.38-.84-.85l-.19-16.3c0-.47.37-.84.82-.84zM4.03 2.99c.23 0 .42.19.42.42 0 .23-.19.42-.42.42h-1.2v16.75h11.73v-.69c0-.23.19-.42.42-.42.23 0 .41.19.41.42V21c0 .23-.18.42-.41.42H2.42c-.23 0-.42-.19-.42-.42V3.41c0-.23.19-.42.42-.42z" fill="#ae74f0"/><path d="M13.834 2.282L13.39 1.8c.03.03.12.07.26.01.15-.05.18-.14.18-.18zM18.19 7.01l-.004-.005zm-.004-.005l-.37-.4.544.005c-.04 0-.11.03-.17.16-.057.124-.033.202-.004.235zM13.86 6.56l-.026-4.278 3.982 4.322zm4.49.89c.59.01.85-.56.45-1.01L14 1.23c-.41-.45-1-.21-1 .4l.02 4.92c0 .46.37.84.83.85zM20.44 13.23H8.86l-2.27-2.06c-.12-.11-.28-.17-.45-.17H.78c-.37 0-.78.19-.78.56V25.4c0 .37.41.78.78.78h19.66c.37 0 .56-.41.56-.78V13.79c0-.37-.19-.56-.56-.56z" fill="#ae74f0"/><path d="M11.38 18.34h7.1M9.44 21.34h9.66" fill="none" stroke="#fff" strokeDasharray="0" strokeLinecap="square"/></svg>

class CreateModal extends Component {

	constructor() {
		super()
		this.createBinderBinded = this.createBinder.bind(this)
		this.checkboxChanged = this.checkboxChanged.bind(this)
		this.state = {
			termsCheckbox: false,
		}
	}

	createBinder() {
		if ((!this.props.user_extra_data || this.props.user_extra_data.hasAcceptedSubsTerms === '0') && !this.state.termsCheckbox) {
			return
		}
		this.props.actions.createBinder(this.props.binders_new.value)
	}

	cancelNewBinder() {
		this.props.actions.cancelBinderCreation()
	}

	changeHandler(changeData) {
		this.props.actions.updateBinderText(changeData)
	}

	componentDidMount() {
		this.props.actions.resetNewBinderForm()
	}

	checkboxChanged() {
		this.setState({
			termsCheckbox: !this.state.termsCheckbox,
		})
	}

	render() {

		const hasAcceptedSubsTerms = this.props.user_extra_data ? this.props.user_extra_data.hasAcceptedSubsTerms !== '0' : false

		const status = this.props.binders_new.error ? 'error':''

		return (
			<Modalizer modalName={this.props.modalName} width='336px' closeAction={() => this.props.actions.closeModal(this.props.modalName)}>
				<div styleName='container'>
					<SecondaryTitle icon={bindersIcon}>{localize('binders_createModal_title')}</SecondaryTitle>
					<TextInput
						onEnterKey={this.createBinderBinded}
						placeholder={localize('binders_createModal_placeholder')}
						message={this.props.binders_new.error}
						status={status}
						value={this.props.binders_new.value}
						onChange={this.changeHandler.bind(this)}
						autoFocus={true}
						maxLength={'100'}
						tabIndex={100} />
					{!hasAcceptedSubsTerms && <div styleName='terms-and-conditions'>
						<CheckboxInput
							onChange={this.checkboxChanged}
							value={this.state.termsCheckbox} />
						<label styleName='terms-and-conditions-label'>{localize('binders_createModal_termsText')} <TextLink href='https://nearpod.com/subs-terms-conditions' target="_blank">{localize('binders_createModal_termsLink')}</TextLink></label>
					</div>}
					<div styleName='btn-bar'>
						<div styleName='btn-bar_button'>
							<CancelButton tabIndex={101} focus={true} onClick={this.cancelNewBinder.bind(this)}>{localize('global_cancel')}</CancelButton>
						</div>
						<div styleName='btn-bar_button'>
							<MainButton tabIndex={102} focus={true} disabled={!hasAcceptedSubsTerms && !this.state.termsCheckbox} onClick={this.createBinderBinded}>{localize('global_create')}</MainButton>
						</div>
					</div>
				</div>
			</Modalizer>
		)
	}
}

CreateModal.propTypes = {
	actions: PropTypes.object,
	binders: PropTypes.object,
	modalName: PropTypes.string,
}

function mapStateToProps(state) {
	return {
		binders_new: state.binders.new,
		user_extra_data: state.user.extra,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		createBinder: binderActions.createBinder,
		cancelBinderCreation: binderActions.cancelBinderCreation,
		updateBinderText: binderActions.updateBinderText,
		resetNewBinderForm: binderActions.resetNewBinderForm,
		closeModal: generalActions.closeModal,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(CreateModal, styles, {allowMultiple: true}))
